module.exports = __webpack_public_path__ + "media/images/anonymous1-842fefa43662074a0780779f35b57f9b.png";